/**
 * Controla o menu que alterna a visualização dos equipmentos parados no mapa
 *
 * @author Adalto Junior Date: 15/05/2014 Time: 11:40
 */

import { getResourceTo, toastNotification } from 'react/utils/utils';

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.EquipmentOff = function (toolbarSelector, map, options) {

    let sessionSourceData,
        onClickFilter,
        coordinatesFiltered

    this.checks = new Greenmile.Storage.StoreMapPosition().getLayerMapFromUser();
    this.fieldEquipmentOff = null;

    if (this.checks === null) {
        this.checks = new Greenmile.Storage.StoreMapPosition().setLayerMapFromUser();
    }

    if (options) {

        if (options.sourceSessionData) {
            sessionSourceData = options.sourceSessionData;
        }

        if (options.equipmentOff) {
            onClickFilter = options.equipmentOff.onClickFilter;
        }

    }


    this.removeIconEquipOff = function () {

        Greenmile.Map.Utility.removeLayerByKind(map, ['equipOffInStop']);
        onClickFilter();

    };

    this.showAlertMessage = function () {
        toastNotification.addToast({
          id: 'track-equipment-no-coordinates',
          type: 'warning',
          variant: 'secondary',
          data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: getResourceTo('RouteDetail.equipmentOff.infoError'),
          }
        });
    };

      this.showEquipmentOffLayer = function () {

          const coordinates = sessionSourceData.positionSources.models.at(0)?.attributes?.coordinates;
          coordinatesFiltered = coordinates?.filterCoordinatesByEquipmentStoppedByMinutes(parseInt(this.fieldEquipmentOff.value, 10) || 0) ?? [];

          if (onClickFilter && coordinatesFiltered.length > 0) {
              onClickFilter(coordinatesFiltered);
          } else {
              this.removeIconEquipOff();
              this.showAlertMessage();
          }

      }


    this.addListeners = function () {

        const strLayerEquipOff = toolbarSelector + " #inputEquipOff";
        this.fieldEquipmentOff = document.querySelector(strLayerEquipOff);
        const userPreferences = new Greenmile.UserPreferences.Actions();

        $(toolbarSelector + " #buttonEquipOff").off();
        $(toolbarSelector + " #buttonEquipOff").on("click", (function (scope) {
            return function () {
                scope.showEquipmentOffLayer();
                Monet.Session.sessionStorage.setItem("stoppedTime", scope.fieldEquipmentOff.value);
                userPreferences.saveOrUpdateSingleUserPreference("stoppedTime");
            };
        }(this)));

        $(toolbarSelector + " #cancelEquipOff").off();
        $(toolbarSelector + " #cancelEquipOff").on("click", (function (scope) {
            return function () {
                document.querySelector(toolbarSelector + " #inputEquipOff").value = "";
                scope.removeIconEquipOff();
            };
        }(this)));

        var validateEvent = function (e) {

            var validateSymbolNegative = $(e.target).val();
            var charSymbol = validateSymbolNegative.match(/[^0-9]/g);
            var hasSymbol = (validateSymbolNegative.match(/[^0-9]/g) !== null ) ? true : false;

            if (hasSymbol) {

                for (var i = 0; i < charSymbol.length; i++) {

                    var x = $(e.target).val().replace(charSymbol[i], "");
                    $(e.target).val(x);

                }

            }
        };

        $(strLayerEquipOff).on("keyup", function (e) {
            validateEvent(e);
        });

        if (this.fieldEquipmentOff) {
            this.fieldEquipmentOff.value = Monet.Session.sessionStorage.getItem("stoppedTime") || 60;
        }

    };

    var init = function (scope) {

        scope.canShowEquipamentsOff = true;

        if (sessionSourceData) {
            sessionSourceData.canShowEquipamentsOff = true;
        }


    };

    init(this);

};
